import { CashFlowItemService } from "./../../../services/catalogs/CashFlowItemService";
import { CashFlowItemDetail } from "./../../../components/Pages/Catalogs/cashflowitem/CashflowItemDetail";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateCashflowItemDto } from "../../../dtos/catalogs/cashflowitem/CreateCashflowItemDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCashflowItem } from "../../../components/Shared/NewForms/NFLookupCashflowItem";
import CashflowItemList from "../../../components/Pages/Catalogs/cashflowitem/CashflowItemList";

export const CashflowItem: IAppEntity = {
  entityType: "catalog",
  title: "Cashflow Item",
  pluralTitle: "CashFlowItems",
  apiUrl: "CashFlowItems",
  apiEnum: ReferenceTypes.CatalogCashFlowItem,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(CashFlowItemDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashflowItemList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCashflowItem, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new CashFlowItemService(this.apiUrl);
  },
  getEmptyModel(): CreateCashflowItemDto {
    return {
      name: "",
      belongTo: 0,
      createdDate: new Date(),
    };
  },
};
